import { Badge, NumberFormatter, Tooltip } from "@mantine/core";
import classes from "./ConfidenceBadge.module.css";

export default function ConfidenceIcon({ confidence }) {
  if (!confidence) return null;
  let color = "green";
  if (confidence < 0.8) color = "yellow";
  if (confidence < 0.6) color = "red";
  return (
    <Tooltip label="The confidence level of the prediction">
      <Badge
        color={color}
        variant="dot"
        classNames={{ label: classes.badgeLabel }}
      >
        <NumberFormatter
          value={confidence * 100}
          suffix=" %"
          decimalScale={2}
        />
      </Badge>
    </Tooltip>
  );
}
